/* =========================================================================
   720 EGONEX — Ortak kaydırmalı şerit (mobil slider)
   Kullanım: <egonex-slider data-dots="true" data-arrows="true" data-autoplay="0">
               <div data-eg-track> ...kartlar... </div>
             </egonex-slider>
   ========================================================================= */
(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class EgonexSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eg-track]');
      if (!this.track) return;
      this.autoplay = parseInt(this.dataset.autoplay, 10) || 0;
      this.bound = false;
      this.setup();

      // Tema editöründe blok eklenip çıkarıldığında kendini tazelesin
      this.mo = new MutationObserver(() => this.setup());
      this.mo.observe(this.track, { childList: true });
    }

    setup() {
      this.slides = Array.from(this.track.children);
      this.classList.toggle('is-single', this.slides.length < 2);

      this.querySelectorAll(':scope > .eg-slider__dots, :scope > .eg-slider__arrow').forEach((el) => el.remove());
      this.prevBtn = this.nextBtn = this.dots = null;
      if (this.slides.length < 2) {
        this.stop();
        return;
      }

      this.buildControls();
      if (!this.bound) {
        this.bind();
        this.bound = true;
      }
      this.update();
      if (this.autoplay) this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.io?.disconnect();
      this.mo?.disconnect();
    }

    buildControls() {
      if (this.dataset.arrows === 'true') {
        this.prevBtn = this.makeBtn('prev');
        this.nextBtn = this.makeBtn('next');
        this.append(this.prevBtn, this.nextBtn);
      }
      if (this.dataset.dots === 'true') {
        this.dots = document.createElement('div');
        this.dots.className = 'eg-slider__dots';
        this.slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'eg-slider__dot';
          b.setAttribute('aria-label', `${i + 1}. görsele git`);
          b.addEventListener('click', () => this.goTo(i));
          this.dots.appendChild(b);
        });
        this.append(this.dots);
      }
    }

    makeBtn(dir) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `eg-slider__arrow eg-slider__arrow--${dir}`;
      b.setAttribute('aria-label', dir === 'prev' ? 'Önceki' : 'Sonraki');
      b.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
        (dir === 'prev' ? 'm14.5 6-6 6 6 6' : 'm9.5 6 6 6-6 6') +
        '"/></svg>';
      b.addEventListener('click', () => this.step(dir === 'prev' ? -1 : 1));
      return b;
    }

    bind() {
      let raf;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.update());
        },
        { passive: true }
      );

      ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((e) =>
        this.addEventListener(e, () => this.stop(), { passive: true })
      );
      this.addEventListener('mouseleave', () => this.autoplay && this.start());

      // Görünmüyorsa otomatik oynatma dursun
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) this.stop();
          else if (this.autoplay) this.start();
        });
      });
      this.io.observe(this);
    }

    get index() {
      const left = this.track.scrollLeft;
      let best = 0;
      let min = Infinity;
      this.slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left);
        if (d < min) {
          min = d;
          best = i;
        }
      });
      return best;
    }

    goTo(i) {
      const target = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
      if (!target) return;
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: reduced ? 'auto' : 'smooth',
      });
    }

    step(dir) {
      const next = this.index + dir;
      this.goTo(next < 0 ? this.slides.length - 1 : next >= this.slides.length ? 0 : next);
    }

    update() {
      const i = this.index;
      if (this.dots) {
        Array.from(this.dots.children).forEach((d, di) => d.classList.toggle('is-active', di === i));
      }
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevBtn?.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      this.nextBtn?.toggleAttribute('disabled', this.track.scrollLeft >= max);
      this.classList.toggle('is-scrollable', this.track.scrollWidth > this.track.clientWidth + 4);
    }

    start() {
      if (reduced || !this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.step(1), this.autoplay);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('egonex-slider')) customElements.define('egonex-slider', EgonexSlider);
})();
